import { useContext, useEffect, useRef, useState } from "react"
import { MyContext } from "../../Context/MyProvider"
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import { Link, useNavigate } from "react-router-dom";
import Banner from "./Banner";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import PageLoading from "../PageLoading";
import OneSignal from 'react-onesignal';
import { useTranslation } from "react-i18next";
import Logo from "../../image/astrotalk-logo.png";

const Home = () => {

  const { t } = useTranslation();
  const { BaseUrl, HandleCallApi, setAgoraAppId, setIsReqModel, setModelData, formatPrice } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState([]);
  const [dynamiclist, setDynamicList] = useState([]);
  const [isRaning, setIsRaning] = useState(false);
  const [raningList, setRaningList] = useState([]);
  const [faqList, setFaqList] = useState([]);
  const [topAstro, setTopAstro] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState(0);
  const [topRatedAstro, setTopRatedAstro] = useState([]);
  const [featureList, setFeatureList] = useState([]);
  const [isInstallable, setIsInstallable] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [activeFaq, setActiveFaq] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const HomeRef = useRef(false);
  const FaqListRef = useRef(false);
  const RaninListgRef = useRef(false);
  const IsRaning = useRef(null);
  const initialized = useRef(null);

  const navigate = useNavigate();

  const Currency = secureLocalStorage.getItem("currency");

  useEffect(() => {

    HandleFechData();
    handleGetRaningApointment();
    handleGetFaqList();

    const isShowStored = secureLocalStorage.getItem("pwa");

    const shouldShowInstall = isShowStored !== null ? isShowStored : true;
    setIsInstallable(shouldShowInstall);

    if (!shouldShowInstall) return;

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };

  }, []);


  const HandleFechData = async () => {
    if (HomeRef.current) return;
    HomeRef.current = true;

    const Userid = secureLocalStorage.getItem("Userid") || "0";
    if (!Userid) {
      setLoading(false);
      return;
    }
    try {
      const Response = await HandleCallApi("Post", "user/home", { id: Userid });
      if (Response && Response.data) {
        const { banner_list, dynamic_list, general_detail, general_feature, user_wallet, top_five_astrologer, category_wise_top_list, live_astrologer, aiplan_is_active, modulsplan_is_active } = Response.data;

        setDynamicList(dynamic_list || []);
        setBanner(banner_list || []);
        setAgoraAppId(general_detail?.agora_app_id || "");
        setTopAstro(top_five_astrologer || []);
        setCategory(category_wise_top_list || []);
        setFeatureList(general_feature || []);
        setTopRatedAstro(live_astrologer || []);
        secureLocalStorage.setItem("currency", general_detail?.site_currency || "$");
        secureLocalStorage.setItem("tex", general_detail?.tax_percentage || "0");
        secureLocalStorage.setItem("isgift", general_detail?.gift_section || "false");
        secureLocalStorage.setItem("default_image", general_detail?.default_image || "uploads/settings/1772771577662default_pic.png");
        secureLocalStorage.setItem("thousands_separator", general_detail?.thousands_separator ?? "1");
        secureLocalStorage.setItem("currency_placement", general_detail?.currency_placement ?? "0");
        secureLocalStorage.setItem("google_map_key", general_detail?.google_map_key || "");
        secureLocalStorage.setItem("userwallet", user_wallet || 0);
        secureLocalStorage.setItem("aishow", aiplan_is_active || "false");
        secureLocalStorage.setItem("modulsshow", modulsplan_is_active || "false");
        secureLocalStorage.setItem("kundli_pdf_status", general_detail?.kundli_pdf_status ?? "0");
        secureLocalStorage.setItem("kundli_pdf_price", general_detail?.kundli_pdf_price ?? "0");

        if (general_detail?.one_app_react_id) {
          handleOneSignal(general_detail?.one_app_react_id);
        }

        if (general_detail?.IsSendRequst == "true") {
          setIsReqModel(true);
          const GetModelData = secureLocalStorage.getItem("modeldata");
          if (GetModelData && GetModelData !== "null" && GetModelData !== "undefined") {
            try {
              const parsedModel = typeof GetModelData === 'string' ? JSON.parse(GetModelData) : GetModelData;
              if (parsedModel) {
                setModelData(parsedModel);
              }
            } catch (e) {
              console.error("Error parsing modeldata in Home:", e);
            }
          }
        }
      }
    } catch (error) {
      console.error("Error loading home page data:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleOneSignal = async (OneSignalUserAppId) => {
    if (!initialized.current) {
      OneSignal.init({
        appId: OneSignalUserAppId,
        safari_web_id: "web.onesignal.auto.xxx",
        notifyButton: {
          enable: true,
        },
        serviceWorkerParam: { scope: "/" },
        serviceWorkerPath: "/OneSignalSDKWorker.js",
        allowLocalhostAsSecureOrigin: true,
      }).then(async () => {
        initialized.current = true;
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid && Userid !== "0") {
          OneSignal.User.addTags({
            "Login_ID": Userid,
            "subscription_user_Type": "user"
          });
        }
      }).catch((error) => {
        // console.error("OneSignal initialization error:", error);
      });
    } else {
      const Userid = secureLocalStorage.getItem("Userid");
      if (Userid && Userid !== "0") {
        OneSignal.User.addTags({
          "Login_ID": Userid,
          "subscription_user_Type": "user"
        });
      }
    }
  };

  const handleGetFaqList = async () => {
    if (FaqListRef.current) return;
    FaqListRef.current = true;
    const Response = await HandleCallApi("Post", "user/faq");
    if (Response?.data) {
      setFaqList(Response.data.faq_data);
    }
  }

  const handleGetRaningApointment = async () => {
    if (RaninListgRef.current) return;
    RaninListgRef.current = true;
    const Userid = secureLocalStorage.getItem("Userid");
    const Response = await HandleCallApi("Post", "user/user_running_appointment", { user_id: Userid });
    if (Response?.data?.ResponseCode == "200") {
      setRaningList(Response.data.appointment);
    }
  }

  const handleModelOpneClose = (index) => {
    let TimeOut;

    if (index === 1) {
      setIsRaning(true);
      TimeOut = setTimeout(() => {
        IsRaning.current.classList.add("raning_box_open");
      }, 100);
    } else {
      IsRaning.current.classList.remove("raning_box_open");
      TimeOut = setTimeout(() => {
        setIsRaning(false);
      }, 300);
    }

    return () => clearTimeout(TimeOut)
  }

  const handleContinueChat = (item) => {
    setIsRaning(false);
    navigate(`/appointment-list`, { state: item?.appointment_id });
  }

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        secureLocalStorage.setItem("pwa", false);
        setDeferredPrompt(null);
        setIsInstallable(false);
      }
    }
  };

  const handleClosePwaCard = () => {
    setIsInstallable(false);
    secureLocalStorage.setItem("pwa", false);
  }

  const uniqueLiveAstrologers = topRatedAstro.filter(
    (liveAstro) => !topAstro.some((top) => top.id === liveAstro.id)
  );
  const displayLiveAstrologers = uniqueLiveAstrologers.length > 0 ? uniqueLiveAstrologers : topRatedAstro;

  return (
    <div className="home_page">

      {!loading && <div className="width_container">

        <div className="banner_section">
          <Banner images={banner} />
        </div>

        <div className="astrologers_section space-y-8">

          {featureList.length > 0 && (
            <div className="space-y-8">
              <h1 className='main_title'>{t("Astrologers")}</h1>
              <p className='main_dec' >{t("Top Astrologers. 24 * 7 customer support. Happy to help")}</p>

              <div>
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={10}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper feature_swiper"
                >
                  {featureList.map((item, index) => {
                    const Title = item.title.replace(/\s+/g, '-').toLowerCase();
                    const getRoute = () => {
                      if (item.title === "Free Kundli") return "/freekundli";
                      if (item.title === "Kundli Maching" || item.title === "Kundli Matching") return "/kundli-matching";
                      if (item.title === "Horoscope") return "/horoscope";
                      return `/cetagory/${Title}`;
                    };
                    return (
                      <SwiperSlide
                        key={index}
                        style={{ width: "170px" }}
                        className="bg-white shadow p-[15px] rounded-[15px] my-[10px] cursor-pointer"
                      >
                        <Link to={getRoute()}>
                          <ImageLoad
                            url={BaseUrl + item?.image}
                            CustomeStyle="w-[60px] h-[70px] mx-auto object-contain"
                            alt="image"
                          />
                          <p className="text-center text-[15px] mt-5">{item.title}</p>
                        </Link>
                      </SwiperSlide>
                    );
                  })}

                </Swiper>
              </div>
            </div>
          )}

          <div className="space-y-8">

            {dynamiclist.map((List, index) => {
              return <div key={index} className="daynamic_box space-y-3">
                <div className="flex items-center justify-between">
                  <h1 className='title'>{List.title}</h1>
                  <Link to="/chat-width-astrologer" state={{ category_id: List.category_id }} className="view_all_btn">
                    {t("View All")}
                  </Link>
                </div>
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={24}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                >
                  {List.astrologer?.map((item, index) => {
                    return (
                      <SwiperSlide key={index} className="card_box group">
                        <Link
                          to={`/astrologers/${item.id}`}
                          state={"home"}
                        >
                          <div className="relative">
                            <ImageLoad
                              url={BaseUrl + item.pimage}
                              alt={item.name || "Astrologer"}
                              CustomeStyle="w-full h-full object-cover"
                            />

                            {item.live_status === 1 && (
                              <div className="card_box_online_badge">
                                <span></span>
                                <h1>{t("Online")}</h1>
                              </div>
                            )}
                          </div>

                          <div className="details_box">
                            <div className="flex items-center justify-between gap-[10px] overflow-hidden">
                              <div className="flex items-center gap-1 overflow-hidden">
                                <h1 className="trime">{item.name}</h1>
                                {item.approve_status === 1 && (
                                  <svg width="18" height="18" className="text-green-600 shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M20.1219 9.88002L19.681 9.43901C19.4 9.15801 19.2419 8.77601 19.2419 8.37801V7.757C19.2419 6.101 17.9 4.75902 16.244 4.75902H15.623C15.225 4.75902 14.844 4.60102 14.562 4.32002L14.1209 3.87901C12.9499 2.70801 11.0519 2.70801 9.88094 3.87901L9.4399 4.32002C9.1589 4.60102 8.77698 4.75902 8.37898 4.75902H7.75801C6.10201 4.75902 4.75996 6.101 4.75996 7.757V8.37801C4.75996 8.77601 4.602 9.15701 4.321 9.43901L3.87996 9.88002C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.88002ZM15.53 10.53L11.53 14.53C11.384 14.676 11.192 14.75 11 14.75C10.808 14.75 10.6159 14.677 10.4699 14.53L8.46992 12.53C8.17692 12.237 8.17692 11.762 8.46992 11.469C8.76293 11.176 9.23796 11.176 9.53096 11.469L11.0009 12.939L14.4709 9.46901C14.7639 9.17601 15.2389 9.17601 15.5319 9.46901C15.8229 9.76201 15.823 10.238 15.53 10.53Z" fill="currentColor"></path>
                                  </svg>
                                )}
                              </div>

                              <div className="card_box_rating_badge">
                                <svg width="12" height="12" className="text-[#eab308]" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                  <path d="M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z" fill="currentColor" />
                                </svg>
                                <span>{item.rating}</span>
                              </div>
                            </div>

                            <p className="trime skills_text">{item.skills}</p>
                            <p className="trime lang_text">{item.lang}</p>

                            <div className="card_box_footer">
                              <div className="card_box_price">
                                {formatPrice(item.off_price)}
                                <span>/{t("min")}</span>
                              </div>
                              <button className="card_box_btn">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                                {t("Chat")}
                              </button>
                            </div>
                          </div>
                        </Link>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            })}

          </div>

          <div className="space-y-5">
            <div className="flex items-center justify-between">
              <h1 className="title">{t("Top Astrologers")}</h1>
              <Link to="/chat-width-astrologer" className="view_all_btn">
                {t("View All")}
              </Link>
            </div>
            <div className="top_astro">

              <Swiper
                slidesPerView={'auto'}
                spaceBetween={20}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
              >
                {topAstro.map((item, index) => {
                  return <SwiperSlide key={index} className="card_box">
                    <Link to={`/astrologers/${item.id}`}>
                      <div className="img relative">
                        <ImageLoad url={BaseUrl + item?.profile_image} CustomeStyle={"w-full h-full object-cover hover:scale-105 bg-center"} alt={"Astrologers img"} />
                        <div className="w-full absolute top-2 flex items-center gap-5 justify-between px-2">
                          <div className="rating">
                            <svg width="12" height="12" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" >
                              <path d="M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z" fill="currentColor" />
                            </svg>
                            <p>{item.rating_astro}</p>
                          </div>
                          {item.live_status === 1 && <div className="flex items-center gap-[5px] bg-green-100 px-3 py-[2px] rounded-[50px]">
                            <span className="size-2 bg-green-500 rounded-full"></span>
                            <h1 className="font-bold uppercase text-[11px] text-green-700">{t("Online")}</h1>
                          </div>}
                        </div>
                      </div>

                      <div className="py-[10px] leading-5 border-b">
                        <div className="flex items-center gap-1">
                          <h1 className="font-medium text-[18px] trime">{item.name}</h1>
                          {item.approve_status === 1 && <svg width="20" height="20" className="text-green-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.1219 9.88002L19.681 9.43901C19.4 9.15801 19.2419 8.77601 19.2419 8.37801V7.757C19.2419 6.101 17.9 4.75902 16.244 4.75902H15.623C15.225 4.75902 14.844 4.60102 14.562 4.32002L14.1209 3.87901C12.9499 2.70801 11.0519 2.70801 9.88094 3.87901L9.4399 4.32002C9.1589 4.60102 8.77698 4.75902 8.37898 4.75902H7.75801C6.10201 4.75902 4.75996 6.101 4.75996 7.757V8.37801C4.75996 8.77601 4.602 9.15701 4.321 9.43901L3.87996 9.88002C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.88002ZM15.53 10.53L11.53 14.53C11.384 14.676 11.192 14.75 11 14.75C10.808 14.75 10.6159 14.677 10.4699 14.53L8.46992 12.53C8.17692 12.237 8.17692 11.762 8.46992 11.469C8.76293 11.176 9.23796 11.176 9.53096 11.469L11.0009 12.939L14.4709 9.46901C14.7639 9.17601 15.2389 9.17601 15.5319 9.46901C15.8229 9.76201 15.823 10.238 15.53 10.53Z" fill="currentColor"></path>
                          </svg>}
                        </div>
                        <p className="text-gray-600 text-[15px] trime">{item.skills}</p>
                      </div>
                      <div className="pt-[10px] leading-5">
                        <h1 className="font-medium text-[14px] uppercase text-gray-600">{t("rate")}</h1>
                        <div>
                          <span className="text-[20px] font-medium">{formatPrice(item.chat_offer_price)}</span>
                          <span className="text-gray-700 text-[14px]">/{t("per min")}</span>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                })}
              </Swiper>

            </div>
          </div>

          <div className="space-y-5">
            <div className="flex items-center justify-between">
              <h1 className="title">{t("Online Astrologers")}</h1>
              <Link to="/chat-width-astrologer" className="view_all_btn">
                {t("View All")}
              </Link>
            </div>
            <div className="top_rated_astro">
              <Swiper
                slidesPerView={'auto'}
                spaceBetween={20}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
              >
                {displayLiveAstrologers.map((item, index) => {
                  return <SwiperSlide key={index} className="card_box">
                    <Link to={`/astrologers/${item.id}`} className="h-full flex flex-col justify-between">
                      <div className="avatar_wrapper">
                        <div className="avatar_circle">
                          <ImageLoad url={BaseUrl + item?.profile_image} CustomeStyle={"w-full h-full object-cover"} alt={"Astrologers img"} />
                        </div>
                        {item.approve_status === 1 && <div className="avatar_verified">
                          <svg width="20" height="20" className="text-green-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M20.1219 9.88002L19.681 9.43901C19.4 9.15801 19.2419 8.77601 19.2419 8.37801V7.757C19.2419 6.101 17.9 4.75902 16.244 4.75902H15.623C15.225 4.75902 14.844 4.60102 14.562 4.32002L14.1209 3.87901C12.9499 2.70801 11.0519 2.70801 9.88094 3.87901L9.4399 4.32002C9.1589 4.60102 8.77698 4.75902 8.37898 4.75902H7.75801C6.10201 4.75902 4.75996 6.101 4.75996 7.757V8.37801C4.75996 8.77601 4.602 9.15701 4.321 9.43901L3.87996 9.88002C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.88002ZM15.53 10.53L11.53 14.53C11.384 14.676 11.192 14.75 11 14.75C10.808 14.75 10.6159 14.677 10.4699 14.53L8.46992 12.53C8.17692 12.237 8.17692 11.762 8.46992 11.469C8.76293 11.176 9.23796 11.176 9.53096 11.469L11.0009 12.939L14.4709 9.46901C14.7639 9.17601 15.2389 9.17601 15.5319 9.46901C15.8229 9.76201 15.823 10.238 15.53 10.53Z" fill="currentColor"></path>
                          </svg>
                        </div>}
                        {Number(item.live_status) === 1 && (
                          <div className="avatar_online animate-pulse"></div>
                        )}
                      </div>


                      <div className="text-center mt-3">
                        <h1 className="font-medium text-[18px] trime">{item.name}</h1>
                        <p className="trime text-[14px] text-gray-600 font-medium">{item.category_names.join(", ")}</p>
                        <div className="flex items-center justify-center gap-[5px]">
                          <svg width="14" height="14" className="text-[#eab308]" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z" fill="currentColor" />
                          </svg>
                          <span className="font-medium text-[15px]">{item.rating_astro}</span>
                          <span className="text-[14px] text-gray-700">({item.total_review} {t("Reviews")})</span>
                        </div>
                        <div>
                          <span className="text-[20px] font-medium">{formatPrice(item.chat_perhours_charge)}</span>
                          <span className="text-gray-700 text-[15px]">/{t("per min")}</span>
                        </div>
                      </div>
                      <button className="w-full text-white bg-[--bgcolor] mt-3 py-[8px] rounded-[10px] font-medium hover:opacity-75 flex items-center gap-[10px] justify-center">
                        <svg width="20" height="20" className="text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14H16M8 10H12M21.9664 11.2166C21.9886 11.4748 22 11.7361 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3H13C13.2639 3 13.5252 3.01136 13.7834 3.03362M22 6C22 7.65685 20.6569 9 19 9C17.3431 9 16 7.65685 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path></svg>
                        {t("Chat Now")}
                      </button>
                    </Link>
                  </SwiperSlide>
                })}
              </Swiper>
            </div>
          </div>

          <div className="space-y-5">
            <div className="flex items-center justify-between">
              <h1 className="title">{t("Astrologer Categories")}</h1>
              {category[selectCategory]?.category_id && (
                <Link to="/chat-width-astrologer" state={{ category_id: category[selectCategory].category_id }} className="view_all_btn">
                  {t("View All")}
                </Link>
              )}
            </div>
            <div className="category">
              <Swiper
                slidesPerView={'auto'}
                spaceBetween={10}
                modules={[Pagination]}
                className="mySwiper"
              >
                {category.map((item, index) => {
                  const IsShow = index === selectCategory;
                  return <SwiperSlide key={index} onClick={() => setSelectCategory(index)} className={IsShow && "select"}>
                    <ImageLoad url={BaseUrl + item?.category_image} CustomeStyle={"w-[20px] h-[20px] object-contain"} alt={"Astrologers img"} />
                    <span>{item.category_title}</span>
                  </SwiperSlide>
                })}
              </Swiper>
            </div>

            <div key={selectCategory} className="select_category">
              <Swiper
                slidesPerView={'auto'}
                spaceBetween={20}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
              >
                {category[selectCategory]?.astrologer_list?.length >= 1
                  ? category[selectCategory]?.astrologer_list?.map((item, index) => {
                    return <SwiperSlide key={index} className="card_box animate_fade_in_card" style={{ animationDelay: `${index * 50}ms` }}>
                      <Link to={`/astrologers/${item.id}`} className="h-full flex flex-col justify-between">
                        <div className="avatar_wrapper">
                          <div className="avatar_circle">
                            <ImageLoad url={BaseUrl + item?.profile_image} CustomeStyle={"w-full h-full object-cover"} alt={"Astrologers img"} />
                          </div>
                          {item.approve_status === 1 && <div className="avatar_verified">
                            <svg width="20" height="20" className="text-green-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M20.1219 9.88002L19.681 9.43901C19.4 9.15801 19.2419 8.77601 19.2419 8.37801V7.757C19.2419 6.101 17.9 4.75902 16.244 4.75902H15.623C15.225 4.75902 14.844 4.60102 14.562 4.32002L14.1209 3.87901C12.9499 2.70801 11.0519 2.70801 9.88094 3.87901L9.4399 4.32002C9.1589 4.60102 8.77698 4.75902 8.37898 4.75902H7.75801C6.10201 4.75902 4.75996 6.101 4.75996 7.757V8.37801C4.75996 8.77601 4.602 9.15701 4.321 9.43901L3.87996 9.88002C2.70896 11.051 2.70896 12.949 3.87996 14.12L4.321 14.561C4.602 14.842 4.75996 15.224 4.75996 15.622V16.243C4.75996 17.899 6.10201 19.241 7.75801 19.241H8.37898C8.77698 19.241 9.1579 19.399 9.4399 19.68L9.88094 20.121C11.0519 21.292 12.9499 21.292 14.1209 20.121L14.562 19.68C14.843 19.399 15.225 19.241 15.623 19.241H16.244C17.9 19.241 19.2419 17.899 19.2419 16.243V15.622C19.2419 15.224 19.4 14.843 19.681 14.561L20.1219 14.12C21.2929 12.949 21.2929 11.051 20.1219 9.88002ZM15.53 10.53L11.53 14.53C11.384 14.676 11.192 14.75 11 14.75C10.808 14.75 10.6159 14.677 10.4699 14.53L8.46992 12.53C8.17692 12.237 8.17692 11.762 8.46992 11.469C8.76293 11.176 9.23796 11.176 9.53096 11.469L11.0009 12.939L14.4709 9.46901C14.7639 9.17601 15.2389 9.17601 15.5319 9.46901C15.8229 9.76201 15.823 10.238 15.53 10.53Z" fill="currentColor"></path>
                            </svg>
                          </div>}
                          {Number(item.live_status) === 1 && (
                            <div className="avatar_online animate-pulse"></div>
                          )}
                        </div>
                        <div className="text-center mt-3">
                          <h1 className="font-medium text-[18px] trime">{item.name}</h1>
                          <p className="trime text-[14px] text-gray-600 font-medium">{category[selectCategory]?.category_title}</p>
                          <div className="flex items-center justify-center gap-[5px]">
                            <svg width="14" height="14" className="text-[#eab308]" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" >
                              <path d="M9.96065 0.59625L11.9027 4.51324C12.0487 4.80824 12.3307 5.01226 12.6577 5.05926L17.1406 5.70721C17.9626 5.82621 18.2906 6.83423 17.6956 7.41223L14.4547 10.5572C14.2177 10.7872 14.1096 11.1182 14.1656 11.4432L14.9066 15.7473C15.0566 16.6203 14.1396 17.2862 13.3536 16.8752L9.46566 14.8403C9.17366 14.6873 8.82563 14.6873 8.53463 14.8403L4.64962 16.8732C3.86262 17.2852 2.94259 16.6182 3.09359 15.7432L3.83468 11.4432C3.89068 11.1182 3.78261 10.7872 3.54561 10.5572L0.304646 7.41223C-0.291354 6.83423 0.0365773 5.82621 0.859577 5.70721L5.34261 5.05926C5.66861 5.01226 5.95061 4.80824 6.09761 4.51324L8.03963 0.59625C8.43063 -0.19875 9.56665 -0.19875 9.96065 0.59625Z" fill="currentColor" />
                            </svg>
                            <span className="font-medium text-[15px]">{item.rating_astro}</span>
                            <span className="text-[14px] text-gray-700">({item.total_review || 0} {t("Reviews")})</span>
                          </div>
                          <div>
                            <span className="text-[20px] font-medium">{formatPrice(item.chat_offer_price)}</span>
                            <span className="text-gray-700 text-[15px]">/{t("per min")}</span>
                          </div>
                        </div>
                        <button className="w-full text-white bg-[--bgcolor] mt-3 py-[8px] rounded-[10px] font-medium hover:opacity-75 flex items-center gap-[10px] justify-center">
                          <svg width="20" height="20" className="text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14H16M8 10H12M21.9664 11.2166C21.9886 11.4748 22 11.7361 22 12C22 16.9706 17.9706 21 13 21H6C3.79086 21 2 19.2091 2 17V12C2 7.02944 6.02944 3 11 3H13C13.2639 3 13.5252 3.01136 13.7834 3.03362M22 6C22 7.65685 20.6569 9 19 9C17.3431 9 16 7.65685 16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path></svg>
                          {t("Chat Now")}
                        </button>
                      </Link>
                    </SwiperSlide>
                  })
                  : <div className="h-[200px] flex justify-center items-center">
                    <h1 className="font-medium text-[20px] text-gray-600">{t("No astrologers found !!")}</h1>
                  </div>
                }
              </Swiper>
            </div>
          </div>

        </div>

        <div className="homepage_faq_section pb-[40px]">
          <h1 className="text-center font-bold text-[32px] text-gray-800 mb-8">{t("Frequently Asked Questions")}</h1>
          <div className="faq_accordion_container max-w-[800px] mx-auto space-y-4">
            {faqList?.map((item, index) => {
              const isOpen = activeFaq === index;
              return (
                <div key={index} className={`faq_accordion_item ${isOpen ? 'active' : ''} border rounded-[12px] bg-white transition-all duration-300 shadow-sm`}>
                  <button
                    onClick={() => setActiveFaq(isOpen ? null : index)}
                    className="w-full flex items-center justify-between p-[20px] text-left focus:outline-none"
                  >
                    <span className="font-semibold text-[18px] text-gray-800 pr-[15px]">{item.title}</span>
                    <span className="faq_accordion_icon transition-transform duration-300 transform">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={`${isOpen ? 'rotate-180' : 'rotate-0'} duration-300`}>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg>
                    </span>
                  </button>
                  <div className={`faq_accordion_content transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-[300px] border-t' : 'max-h-0'}`}>
                    <p className="p-[20px] text-[16px] text-gray-600 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {raningList?.length >= 1 && <button onClick={() => handleModelOpneClose(1)} className="running_fab">
          <div className="fab_icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <span className="fab_pulse"></span>
          </div>
          {t("Active Session")} ({raningList.length})
        </button>}

        {isRaning && <div ref={IsRaning} className="raning_box scroll_container">
          <div className="running_panel_header">
            <div className="header_left">
              <div className="header_icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <h2>{t("Running Appointments")}</h2>
            </div>
            <button onClick={() => handleModelOpneClose(2)} className="close_btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div className="running_panel_body">
            <div className="count_badge">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              {raningList.length} {t("Active")} {raningList.length === 1 ? t("Session") : t("Sessions")}
            </div>
            {raningList.map((item, index) => {
              const typeClass = item.appointment_type?.toLowerCase() === 'chat' ? 'chat' : item.appointment_type?.toLowerCase() === 'audio' ? 'audio' : 'video';
              return <div key={index} className="running_appt_card" style={{ animationDelay: `${index * 80}ms` }}>
                <div className="card_top">
                  <img src={BaseUrl + item.astro_image} className="astro_avatar" alt={`${item.astro_name}`} />
                  <div className="astro_info">
                    <h3>{item.astro_name}</h3>
                    <span className="price_tag">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                      </svg>
                      {formatPrice(item.offer_price)}/{t("min")}
                    </span>
                  </div>
                  <span className={`type_badge ${typeClass}`}>
                    {item.appointment_type === 'Chat' && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>}
                    {item.appointment_type === 'Audio' && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>}
                    {item.appointment_type === 'Video' && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>}
                    {item.appointment_type}
                  </span>
                </div>
                <div className="card_action">
                  <button onClick={() => handleContinueChat(item)} className="continue_btn">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                    {t("Continue")}
                  </button>
                </div>
              </div>
            })}
          </div>

        </div>}

        {isRaning && <div onClick={() => handleModelOpneClose(2)} style={{ zIndex: "8888" }} className="overlay"></div>}

      </div>}

      {(!loading && isInstallable) && <div className="pwa_card">
        <div className="bg-white p-[20px] rounded-[12px] shadow-[0_0_5px_0] shadow-black/30">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-[15px] pb-[10px]">
              <img src={Logo} className='w-[80px] sm:w-[60px] rounded-full' alt="logo" />
              <div className="">
                <h1 className='font-[500] text-[17px] sm:text-[16px] text-gray-700'>AstroSpace</h1>
                <p className='text-[14px] sm:text-[12px] text-gray-500'>{BaseUrl}</p>
              </div>
            </div>
            <button onClick={handleClosePwaCard}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
              </svg>
            </button>
          </div>
          <h1 className='text-[15px] sm:text-[14px] my-[5px] font-[500] text-gray-700'>{t("Install Progressive Web Application")}</h1>
          <p className='text-[14px] sm:text-[12px] text-gray-500'>{t("This site has app functionality. Install it on your device for extensive experience and easy access.")}</p>
          <div className="w-full flex justify-end mt-[10px]">
            <button onClick={handleInstallClick} className='font-[500] border-[1px] border-[black] text-black hover:bg-[#000000c4] duration-[.30s] hover:text-white px-[20px] py-[5px] rounded-[10px]'>
              {t("Install")}
            </button>
          </div>
        </div>
      </div>}

      <PageLoading loading={loading} />

    </div>
  )
}

export default Home